import { render, staticRenderFns } from "./VNotificationsView.vue?vue&type=template&id=569c7e70"
import script from "./VNotificationsView.vue?vue&type=script&lang=js"
export * from "./VNotificationsView.vue?vue&type=script&lang=js"
import style0 from "./VNotificationsView.vue?vue&type=style&index=0&id=569c7e70&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('569c7e70')) {
      api.createRecord('569c7e70', component.options)
    } else {
      api.reload('569c7e70', component.options)
    }
    module.hot.accept("./VNotificationsView.vue?vue&type=template&id=569c7e70", function () {
      api.rerender('569c7e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/common/VNotificationsView.vue"
export default component.exports